/**
 * 切换清晰度的模式
 */
export var SET_LEVEL_MODE;
(function (SET_LEVEL_MODE) {
    /** 多video标签预加载切换 */
    SET_LEVEL_MODE["SOFT"] = "soft";
    /** 黑屏重置src切换 */
    SET_LEVEL_MODE["HARD"] = "hard";
    /** 无缝切换（依赖播放库实现） */
    SET_LEVEL_MODE["SMOOTH"] = "smooth";
})(SET_LEVEL_MODE || (SET_LEVEL_MODE = {}));
/**
 * 播放模式枚举：点播/直播
 */
export var PLAY_MODE;
(function (PLAY_MODE) {
    PLAY_MODE["VOD"] = "vod";
    PLAY_MODE["LIVE"] = "live";
})(PLAY_MODE || (PLAY_MODE = {}));
/**
 * 表示内核支持所有的格式。（如果是部分支持，则为['mp4']、['flv']此类数组）
 */
export var CAN_PLAY_ALL = null;
/**
 * 内部创建的video标签容器的class名
 */
export var VIDEO_CONTAINER_CLASS = 'txp_videos_container';
/**
 * 播放结束时的状态枚举，用于区分播放结束的原因
 * @enum {string}
 */
export var END_STATE;
(function (END_STATE) {
    /** 正常结束（到底视频结束点播放完成） */
    END_STATE["NORMAL"] = "normal";
    /** 中断播放（未播放完成时被结束） */
    END_STATE["INTERRUPT"] = "interrupt";
    /** 播放出错 */
    END_STATE["ERROR"] = "error";
})(END_STATE || (END_STATE = {}));
/**
 * video标签的ready state枚举
 */
export var VIDEO_READY_STATE;
(function (VIDEO_READY_STATE) {
    VIDEO_READY_STATE[VIDEO_READY_STATE["HAVE_NOTHING"] = 0] = "HAVE_NOTHING";
    VIDEO_READY_STATE[VIDEO_READY_STATE["HAVE_METADATA"] = 1] = "HAVE_METADATA";
    VIDEO_READY_STATE[VIDEO_READY_STATE["HAVE_CURRENT_DATA"] = 2] = "HAVE_CURRENT_DATA";
    VIDEO_READY_STATE[VIDEO_READY_STATE["HAVE_FUTURE_DATA"] = 3] = "HAVE_FUTURE_DATA";
    VIDEO_READY_STATE[VIDEO_READY_STATE["HAVE_ENOUGH_DATA"] = 4] = "HAVE_ENOUGH_DATA";
})(VIDEO_READY_STATE || (VIDEO_READY_STATE = {}));
/**
 * video标签事件列表
 */
export var VIDEO_EVTS;
(function (VIDEO_EVTS) {
    VIDEO_EVTS["loadstart"] = "loadstart";
    VIDEO_EVTS["timeupdate"] = "timeupdate";
    VIDEO_EVTS["durationchange"] = "durationchange";
    VIDEO_EVTS["volumechange"] = "volumechange";
    VIDEO_EVTS["canplay"] = "canplay";
    VIDEO_EVTS["playing"] = "playing";
    VIDEO_EVTS["pause"] = "pause";
    VIDEO_EVTS["waiting"] = "waiting";
    VIDEO_EVTS["seeking"] = "seeking";
    VIDEO_EVTS["seeked"] = "seeked";
    VIDEO_EVTS["loadeddata"] = "loadeddata";
    VIDEO_EVTS["loadedmetadata"] = "loadedmetadata";
    VIDEO_EVTS["ended"] = "ended";
    VIDEO_EVTS["error"] = "error";
    VIDEO_EVTS["progress"] = "progress";
    VIDEO_EVTS["ratechange"] = "ratechange";
    VIDEO_EVTS["resize"] = "resize";
    /** wasm FakeVideo 专用 */
    VIDEO_EVTS["frameRender"] = "videoFrameRender";
})(VIDEO_EVTS || (VIDEO_EVTS = {}));
/**
 * 标记播放器状态
 * @enum {string}
 */
export var VIDEO_STATE;
(function (VIDEO_STATE) {
    VIDEO_STATE["IDLE"] = "idle";
    VIDEO_STATE["LOAD_START"] = "loadStart";
    /** 当浏览器能够开始播放指定的音频/视频时，但尚未开始播放 */
    VIDEO_STATE["CANPLAY"] = "canplay";
    VIDEO_STATE["PLAYING"] = "playing";
    VIDEO_STATE["PAUSE"] = "pause";
    VIDEO_STATE["SEEKING"] = "seeking";
    VIDEO_STATE["SEEKED"] = "seeked";
    VIDEO_STATE["BUFFERING"] = "buffering";
    /** 正常播放结束（包括外部中断播放），如果是播放出错则没有此状态 */
    VIDEO_STATE["END"] = "end";
})(VIDEO_STATE || (VIDEO_STATE = {}));
/** @deprecated 后续请使用ErrorBase进行比对 */
export var ERROR_CODE;
(function (ERROR_CODE) {
    ERROR_CODE["UNKNOWN_ERR"] = "70011000";
    /** video标签抛出来的错误1：视频取回被终止 */
    ERROR_CODE["MEDIA_ERR_ABORTED"] = "70016001";
    /** video标签抛出来的错误2：H5下载视频错误 */
    ERROR_CODE["MEDIA_ERR_NETWORK"] = "70016002";
    /** video标签抛出来的错误3：H5视频解码错误 */
    ERROR_CODE["MEDIA_ERR_DECODE"] = "70011102";
    /** video标签抛出来的错误4：H5不支持该音视频 */
    ERROR_CODE["MEDIA_ERR_SRC_NOT_SUPPORTED"] = "70011103";
    /**
     * 初次播放超时
     * 注意：目前是判断从开始加载视频到canplay/playing的过程耗时，因此这里的原因可能是
     * 1. 加载视频超时（较大概率）
     * 2. 指定了起播时间，但是无法跳转到对应时间导致超时（目标点无buffer数据等）
     * 3. 其他无法触发canplay/playing事件，但又不报错的情况
     */
    ERROR_CODE["ORG_LOAD_TIMEOUT"] = "70011104";
    /** 状态超过最大停滞时间 */
    ERROR_CODE["STATE_STUCK"] = "70011105";
    /** 播放时间超过最大停滞时间 */
    ERROR_CODE["ORG_PLAY_STUCK_ERR"] = "70011111";
    ERROR_CODE["NULL_URL"] = "70011112";
    ERROR_CODE["MISSING_KERNEL"] = "70011113";
    ERROR_CODE["KERNEL_NOT_SPT"] = "70011114";
})(ERROR_CODE || (ERROR_CODE = {}));
/** @deprecated 已迁移至 i18nConfig 中，访问 i18nConfig.core.ERROR_XXX */
export var ERROR_MSG;
(function (ERROR_MSG) {
    ERROR_MSG["UNKNOWN"] = "\u672A\u77E5\u9519\u8BEF";
    ERROR_MSG["XHR_NET"] = "\u89C6\u9891\u83B7\u53D6\u9014\u4E2D\u51FA\u73B0\u95EE\u9898";
    // PRESET_MODULE_LOAD = 'preset module failed to load',
    ERROR_MSG["PRELOAD_VIDEO_TIMEOUT"] = "\u89C6\u9891\u64AD\u653E\u8D85\u65F6";
    ERROR_MSG["PLAY_STUCK"] = "\u89C6\u9891\u65E0\u6CD5\u7EE7\u7EED\u64AD\u653E";
    ERROR_MSG["LOAD_STREAM_FAIL"] = "\u89C6\u9891\u6D41\u83B7\u53D6\u9014\u4E2D\u51FA\u73B0\u95EE\u9898";
    ERROR_MSG["INNER"] = "\u5185\u90E8\u9519\u8BEF";
    ERROR_MSG["NULL_URL"] = "\u4F20\u5165\u7684\u5730\u5740\u4E3A\u7A7A";
})(ERROR_MSG || (ERROR_MSG = {}));
/**
 * 播放事件定义
 */
export var PLAY_EVENT;
(function (PLAY_EVENT) {
    /** 重新播放 */
    PLAY_EVENT["RESTART"] = "restart";
    PLAY_EVENT["TIME_UPDATE"] = "timeupdate";
    PLAY_EVENT["METADATA_CHANGE"] = "metadataChange";
    PLAY_EVENT["RATE_CHANGE"] = "rateChange";
    PLAY_EVENT["VOLUME_CHANGE"] = "volumeChange";
    PLAY_EVENT["DURATION_CHANGE"] = "durationChange";
    /** 自动播放被阻止 */
    PLAY_EVENT["AUTOPLAY_BLOCKED"] = "autoplayBlocked";
    /** 加载进度变化时（只有mse模式下有自定义加载，才会发出此事件） */
    PLAY_EVENT["LOAD_PROGRESS"] = "loadProgress";
    PLAY_EVENT["STATE_CHANGE"] = "stateChange";
    /** 是否是否首次开播(即使当前播放列表有多个视频，也只有一次此事件，而且一定是看到画面) */
    PLAY_EVENT["FIRST_PLAYING"] = "firstPlaying";
    /** 每一段播放结束 */
    PLAY_EVENT["VIDEONODE_PLAY_OVER"] = "videoNodePlayOver";
    /** 每一段视频开始播放时候（可能并未看到画面，只是切到此视频开始加载） */
    PLAY_EVENT["VIDEONODE_START_PLAY"] = "videoNodeStartPlay";
    /** 每一段视频是否首次开播(一定是看到画面) */
    PLAY_EVENT["VIDEONODE_FIRST_PLAYING"] = "videoNodeFirstPlaying";
    /** 每一段视频准备播放（player列表的当前索引变化）* */
    PLAY_EVENT["VIDEONODE_CHANGE"] = "videoNodeChange";
    /** 播放列表发生变化（每次列表变化，都只是变化当前播放地址后面的列表） */
    PLAY_EVENT["LIST_CHANGE"] = "listChange";
    /** 通知外部是否显示loading动画 */
    PLAY_EVENT["SET_LOADING"] = "setLoading";
    /** 列表预加载开始事件，多视频预加载只会通知一次 */
    PLAY_EVENT["PRELOAD_START"] = "preloadStart";
    /** 单个视频预加载结束事件，多视频预加载每个视频都会通知 */
    PLAY_EVENT["PRELOAD_VIDEONODE_OVER"] = "preloadVideonodeOver";
    /** 单个视频预加载清除事件，多视频预加载每个视频都会通知 */
    PLAY_EVENT["PRELOAD_VIDEONODE_CLEAR"] = "preloadVideonodeClear";
    /** 单个视频预加载错误事件，多视频预加载每个视频都会通知 */
    PLAY_EVENT["PRELOAD_VIDEONODE_ERROR"] = "preloadVideonodeError";
    /** video标签的buffered属性变化时 */
    PLAY_EVENT["VIDEO_BUFFER_CHANGE"] = "videoBufferChange";
    /** 切换清晰度开始 */
    PLAY_EVENT["SETLEVEL_START"] = "setLevelStart";
    /** 切换清晰度成功or失败 */
    PLAY_EVENT["SETLEVEL_OVER"] = "setLevelOver";
    /** 切换音轨开始 */
    PLAY_EVENT["SET_AUDIO_TRACK_START"] = "setAudioTrackStart";
    /** 切换音轨成功or失败 */
    PLAY_EVENT["SET_AUDIO_TRACK_OVER"] = "setAudioTrackOver";
    PLAY_EVENT["RESIZE"] = "resize";
    PLAY_EVENT["STOPED"] = "stoped";
    PLAY_EVENT["ERROR"] = "error";
    PLAY_EVENT["RETRY_BACKURL"] = "retryBackUrl";
    /** 视频帧渲染时长（仅特定内核有效，例如wasm内核） */
    PLAY_EVENT["VIDEO_FRAME_RENDER"] = "videoFrameRender";
    /** 透传video的事件 */
    PLAY_EVENT["ELEMENT_EVTS"] = "elementEvts";
    /** 视频分辨率发生变化 */
    PLAY_EVENT["VIDEO_RESIZE"] = "videoResize";
    /** 全屏变化 */
    PLAY_EVENT["FULLSCREEN_CHANGE"] = "fullscreenChange";
    /** 播放器容器尺寸变化 */
    PLAY_EVENT["CONTAINER_RESIZE"] = "containerResize";
    /** 进入插入流播放 */
    PLAY_EVENT["ENTER_INSERT_STREAM"] = "enterInsertStream";
    /** 退出插入流播放 */
    PLAY_EVENT["EXIT_INSERT_STREAM"] = "exitInsertStream";
})(PLAY_EVENT || (PLAY_EVENT = {}));
/**
 * @ignore
 */
export var PRELOAD_EVENT;
(function (PRELOAD_EVENT) {
    /** 开始预加载 */
    PRELOAD_EVENT["START"] = "START_PRELOAD";
    /**  停止预加载 */
    PRELOAD_EVENT["STOP"] = "STOP_PRELOAD";
    /** 更新预加载信息 */
    PRELOAD_EVENT["UPDATE"] = "UPDATE_PRELOAD_INFO";
})(PRELOAD_EVENT || (PRELOAD_EVENT = {}));
;
export var VIDEO_NODE_EVENT;
(function (VIDEO_NODE_EVENT) {
    VIDEO_NODE_EVENT["TIME_UPDATE"] = "vn_timeupdate";
    VIDEO_NODE_EVENT["METADATA_CHANGE"] = "vn_metadataChange";
    VIDEO_NODE_EVENT["VOLUME_CHANGE"] = "vn_volumeChange";
    VIDEO_NODE_EVENT["DURATION_CHANGE"] = "vn_durationChange";
    VIDEO_NODE_EVENT["PLAY_PROMISE_CATCHED"] = "vn_playPromiseCatched";
    /** 加载进度变化时（只有mse模式下有自定义加载，才会发出此事件） */
    VIDEO_NODE_EVENT["LOAD_PROGRESS"] = "vn_loadProgress";
    VIDEO_NODE_EVENT["RATE_CHANGE"] = "vn_rateChange";
    /**
     * 当有数据append到sourcebuffer中时（只有mse模式下有自定义加载，才会发出此事件）
     * @ignore
     */
    VIDEO_NODE_EVENT["BUFFER_APPENDED"] = "vn_bufferAppended";
    VIDEO_NODE_EVENT["STATE_CHANGE"] = "vn_stateChange";
    VIDEO_NODE_EVENT["ERROR"] = "vn_error";
    /** videonode触发url重试 */
    VIDEO_NODE_EVENT["RETRY"] = "vn_retry";
    VIDEO_NODE_EVENT["SET_LOADING"] = "vn_setLoading";
    /** video标签的buffered属性变化时 */
    VIDEO_NODE_EVENT["VIDEO_BUFFER_CHANGE"] = "vn_videoBufferChange";
    /** 切换清晰度开始 */
    VIDEO_NODE_EVENT["SETLEVEL_START"] = "vn_setLevelStart";
    /** 切换清晰度成功or失败 */
    VIDEO_NODE_EVENT["SETLEVEL_OVER"] = "vn_setLevelOver";
    /** 切换音轨开始 */
    VIDEO_NODE_EVENT["SET_AUDIO_TRACK_START"] = "vn_setAudioTrackStart";
    /** 切换音轨成功or失败 */
    VIDEO_NODE_EVENT["SET_AUDIO_TRACK_OVER"] = "vn_setAudioTrackOver";
    /** VideoNode中的地址变化 */
    VIDEO_NODE_EVENT["URL_CHANGE"] = "vn_urlChange";
    /** 是否是否首次开播 */
    VIDEO_NODE_EVENT["FIRST_PLAYING"] = "vn_firstPlaying";
    /** 透传video的事件 */
    VIDEO_NODE_EVENT["ELEMENT_EVTS"] = "vn_elementEvts";
    /** videonode正常结束 */
    VIDEO_NODE_EVENT["PLAY_OVER"] = "vn_playOver";
    /** 视频分辨率发生变化 */
    VIDEO_NODE_EVENT["VIDEO_RESIZE"] = "vn_videoResize";
    /** 视频帧渲染时长（仅特定内核有效，例如wasm内核） */
    VIDEO_NODE_EVENT["VIDEO_FRAME_RENDER"] = "vn_videoFrameRender";
    /** 进入插入流播放 */
    VIDEO_NODE_EVENT["ENTER_INSERT_STREAM"] = "enterInsertStream";
    /** 退出插入流播放 */
    VIDEO_NODE_EVENT["EXIT_INSERT_STREAM"] = "exitInsertStream";
})(VIDEO_NODE_EVENT || (VIDEO_NODE_EVENT = {}));
/**
 * @ignore
 */
export var PAUSE_TYPE;
(function (PAUSE_TYPE) {
    PAUSE_TYPE["USER"] = "user";
    PAUSE_TYPE["INNER"] = "inner";
    PAUSE_TYPE["SYS"] = "sys";
})(PAUSE_TYPE || (PAUSE_TYPE = {}));
/** 开启播放器的日志等级 */
export var PLAYER_LOG_LEVEL;
(function (PLAYER_LOG_LEVEL) {
    /** 不打开日志 */
    PLAYER_LOG_LEVEL[PLAYER_LOG_LEVEL["NONE"] = 0] = "NONE";
    /** 开启core的日志 */
    PLAYER_LOG_LEVEL[PLAYER_LOG_LEVEL["CORE"] = 1] = "CORE";
    /** 开启内核日志 */
    PLAYER_LOG_LEVEL[PLAYER_LOG_LEVEL["KERNEL"] = 2] = "KERNEL";
})(PLAYER_LOG_LEVEL || (PLAYER_LOG_LEVEL = {}));
/**
 * 预加载策略类型
 */
export var PRELOAD_TYPE;
(function (PRELOAD_TYPE) {
    /** 仅加载视频头部数据，最小流量消耗 */
    PRELOAD_TYPE["META_DATA"] = "metadata";
    /** 由浏览器自行决定加载数据大小，仅赋值src属性 */
    PRELOAD_TYPE["AUTO"] = "auto";
    /** 由浏览器自行决定加载数据大小，同时调用HTMLVideoElement的load()接口，可能会加载整个视频，属于最大流量消耗 */
    PRELOAD_TYPE["AUTO_LOAD"] = "autoLoad";
})(PRELOAD_TYPE || (PRELOAD_TYPE = {}));
/** @deprecated codec枚举 */
export var CODEC;
(function (CODEC) {
    CODEC[CODEC["H264"] = 0] = "H264";
    CODEC[CODEC["H265"] = 1] = "H265";
    CODEC[CODEC["AV1"] = 2] = "AV1";
})(CODEC || (CODEC = {}));
/** 视频codec枚举 */
export var VIDEO_CODEC;
(function (VIDEO_CODEC) {
    /** 未知编码 */
    VIDEO_CODEC["UNKNOWN"] = "unknown";
    VIDEO_CODEC["H264"] = "h264";
    VIDEO_CODEC["H265"] = "h265";
    VIDEO_CODEC["H266"] = "h266";
    VIDEO_CODEC["VP8"] = "vp8";
    VIDEO_CODEC["VP9"] = "vp9";
    VIDEO_CODEC["AV1"] = "av1";
    VIDEO_CODEC["DOLBY_VISION"] = "dolbyVision";
})(VIDEO_CODEC || (VIDEO_CODEC = {}));
/** 音频codec枚举 */
export var AUDIO_CODEC;
(function (AUDIO_CODEC) {
    AUDIO_CODEC["AAC"] = "aac";
    AUDIO_CODEC["OPUS"] = "opus";
})(AUDIO_CODEC || (AUDIO_CODEC = {}));
/** 封装容器枚举 */
export var CONTAINER_FORMAT;
(function (CONTAINER_FORMAT) {
    CONTAINER_FORMAT["MPEG_TS"] = "mpegts";
    CONTAINER_FORMAT["FMP4"] = "fmp4";
    CONTAINER_FORMAT["MP4"] = "mp4";
})(CONTAINER_FORMAT || (CONTAINER_FORMAT = {}));
/** HDR支持能力枚举 */
export var HDR_CAPABILITY;
(function (HDR_CAPABILITY) {
    /** 不支持 */
    HDR_CAPABILITY[HDR_CAPABILITY["NOT_SUPPORTED"] = 0] = "NOT_SUPPORTED";
    /** 不支持HDR，但显示器支持广色域（display p3等），可以通过tone mapping降级到SDR播放 */
    HDR_CAPABILITY[HDR_CAPABILITY["WCG_DISPLAY_BUT_NO_HDR"] = 1] = "WCG_DISPLAY_BUT_NO_HDR";
    /** 支持HDR */
    HDR_CAPABILITY[HDR_CAPABILITY["SUPPORTED"] = 2] = "SUPPORTED";
})(HDR_CAPABILITY || (HDR_CAPABILITY = {}));
/**
 * video标签的状态：被占用/被释放
 */
export var VIDEO_ELEMENT_STATE;
(function (VIDEO_ELEMENT_STATE) {
    VIDEO_ELEMENT_STATE["FREE"] = "0";
    VIDEO_ELEMENT_STATE["USED"] = "1";
})(VIDEO_ELEMENT_STATE || (VIDEO_ELEMENT_STATE = {}));
;
export var CDN_PATH_PREFIX = '//vm.gtimg.cn/thumbplayer/';
export var CACHE_SIZE_KEY;
(function (CACHE_SIZE_KEY) {
    CACHE_SIZE_KEY["DEMUX"] = "demux_cache_size";
})(CACHE_SIZE_KEY || (CACHE_SIZE_KEY = {}));
export var DRM_TYPE;
(function (DRM_TYPE) {
    DRM_TYPE["FAIRPLAY"] = "fairplay";
    DRM_TYPE["WIDEVINE"] = "widevine";
    DRM_TYPE["PLAYREADY"] = "playready";
    DRM_TYPE["CHACHA"] = "chacha";
    DRM_TYPE["NONE"] = "none";
})(DRM_TYPE || (DRM_TYPE = {}));
/** 可播放格式能力枚举 */
export var VIDEO_TYPE;
(function (VIDEO_TYPE) {
    VIDEO_TYPE["HLS"] = "hls";
    VIDEO_TYPE["MP4"] = "mp4";
    VIDEO_TYPE["MOV"] = "mov";
    VIDEO_TYPE["FLV"] = "flv";
    VIDEO_TYPE["WEBRTC"] = "webrtc";
    VIDEO_TYPE["AVI"] = "avi";
    VIDEO_TYPE["MPEG"] = "mpeg";
    VIDEO_TYPE["WEBM"] = "webm";
    VIDEO_TYPE["OGG"] = "ogg";
    VIDEO_TYPE["OTHER"] = "other";
})(VIDEO_TYPE || (VIDEO_TYPE = {}));
export var KERNEL_NAME;
(function (KERNEL_NAME) {
    KERNEL_NAME["ORIGIN"] = "origin";
    KERNEL_NAME["DEMUX_2_FMP4"] = "demux2fmp4";
    KERNEL_NAME["FLV_JS"] = "flv.js";
    KERNEL_NAME["HLS_JS"] = "hls.js";
    KERNEL_NAME["WASM"] = "wasm";
    KERNEL_NAME["WEBRTC"] = "webrtc";
    KERNEL_NAME["ELECTRON"] = "electron";
})(KERNEL_NAME || (KERNEL_NAME = {}));
;
